import script from "./BaseItemDialogTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseItemDialogTabs.vue?vue&type=script&setup=true&lang=ts"

import "./BaseItemDialogTabs.vue?vue&type=style&index=0&id=5a090114&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a090114"]])

export default __exports__
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanels});
